import { render, staticRenderFns } from "./ProDetail.vue?vue&type=template&id=79c13add&scoped=true&"
import script from "./ProDetail.vue?vue&type=script&lang=ts&"
export * from "./ProDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProDetail.vue?vue&type=style&index=0&id=79c13add&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c13add",
  null
  
)

export default component.exports